// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"9bd9dc35","329":"bbf194c2","346":"411e3a79","453":"ed63f173","455":"6518d289","977":"053e75ff"}[chunkId] + ".chunk.js";
};